import React from 'react';

import styles from './style.module.scss';

interface Props {
  children: any;
  color: string;
}

export default (props: Props) => {
  return (
    <span className={styles.highlightContainer}>
      <span style={{ position: 'relative', zIndex: 2 }}>{props.children}</span>

      <span
        className={styles.highlight}
        style={{ backgroundColor: props.color }}
      />
    </span>
  );
};
